import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import StaticPageService from "../services/StaticPageService";

export const StaticPageContext = createContext("StaticPageContext");

const StaticPageContextProvider = ({ children }) => {
	const [staticPageList, setStaticPageList] = useState([]);
	const [loadingStaticPageList, setLoadingStaticPageList] = useState(false);
	const [staticPageListErrorMsg, setStaticPageListErrorMsg] = useState("");

	const getStaticPageList = async (params) => {
		setLoadingStaticPageList(true);
		setStaticPageListErrorMsg("");
		try {
			const response = await StaticPageService.getStaticPagesList(params);
			setStaticPageList(response.data);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setStaticPageListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingStaticPageList(false);
		}
	};

	return (
		<StaticPageContext.Provider
			value={{
				getStaticPageList,
				staticPageList,
				loadingStaticPageList,
				staticPageListErrorMsg,
			}}
		>
			{children}
		</StaticPageContext.Provider>
	);
};

export default StaticPageContextProvider;
